import React from "react";

import { formatDate, formatNumber } from "../../../../Helpers/formatters";

import EditIcon from "@mui/icons-material/Edit";
import ToolTip from "../../../../Components/Interactive/ToolTip";

const CustomerPrograms = ({
  programData,
  handleOpenEdit,
  handleOpenCancel,
  isDefined,
  open,
}) => {
  return programData.programInfo.map((program, idx) => {
    const isActive =
      program.subscriptionStatus.charAt(0) +
      program.subscriptionStatus.slice(1).toLowerCase();
    return (
      <div key={idx}>
        {open && isDefined() && (
          <>
            <EditIcon
              onClick={(e) => handleOpenEdit(e, program)}
              className="edit-info-btn-prog"
            />
          </>
        )}
        <div className="data-highlight">
          <h6>Program Name</h6>
          <p>{program.programName}</p>
        </div>
        <ToolTip
          placement="left"
          titleHeading="Product ID"
          titleData={program.productId}
        >
          <div className="data-highlight">
            <h6>Product Name</h6>
            <p>{isActive === "Active" || isActive === "Paused" ? program.productName : "n/a"}</p>
          </div>
        </ToolTip>
        { program.isPrimary && (
          <div className="data-highlight">
            <h6>Product Thresholds</h6>
            <p>People: {program.peopleReportThreshold === 1000 ? 100 : program.peopleReportThreshold}</p>
            <p>Property: {program.propertyReportThreshold === 1000 ? 100 : program.propertyReportThreshold}</p>
            <p>Phone: {program.phoneReportThreshold === 1000 ? 100 : program.phoneReportThreshold}</p>
            <p>Social: {program.socialReportThreshold === 1000 ? 100 : program.socialReportThreshold}</p>
            <p>Auto: {program.autoReportThreshold === 1000 ? 100 : program.autoReportThreshold}</p>
          </div>
          )}

        <div className="data-highlight">
          <h6>Next Bill $</h6>
          <p>{isActive === "Active" || isActive === "Paused" ? formatNumber(program) : "n/a"}</p>
        </div>
        <div className="data-highlight">
          <h6>Billing Date</h6>
          <p>{isActive === "Active" || isActive === "Paused" ? formatDate(program.billingDate) : "n/a"}</p>
        </div>
        <div className="data-highlight">
          <h6>Enrollment Date</h6>
          <p>{formatDate(program.dateAdded)}</p>
        </div>
        { program.cancelDate !== undefined && (
        <div className="data-highlight">
          <h6>Cancel Date</h6>
          <p>{formatDate(program.cancelDate)}</p>
        </div>
        )}
        <ToolTip
          placement="left"
          titleHeading="Subscription ID"
          titleData={program.subscriptionId}
        >
          <div className="data-highlight">
            <h6>Subscription Status</h6>
            <p>{isActive}</p>
            {isActive === "Active" && (
              <div
                onClick={(e) => handleOpenCancel(e, program)}
                className="cancel-program"
              >
                Cancel
              </div>
            )}
          </div>
        </ToolTip>
        {idx === 0 && programData.programInfo.length > 1 && (
          <hr className="hr" />
        )}
      </div>
    );
  });
};

export default CustomerPrograms;
